import { css } from '@adornis/chemistry/directives/css';
import { html, nothing } from 'lit';

export const injectColorfulStuffForForms = (width: number) => {
  return width > 875
    ? html`
        <img
          ${css({ position: 'absolute', left: '-10px', top: '140px' })}
          src=${require('client/assets/svgs_home/Half_Circle_1.svg')}
          style="width: 144px; height: 72px;"
        />

        <img
          ${css({ position: 'absolute', left: '9%', top: '280px' })}
          src=${require('client/assets/Pattern_full.svg')}
          style="width: 164px; height: 72px;"
        />

        <img
          src=${require('client/assets/background_images/half_circle_blue_full.svg')}
          ${css({ position: 'absolute', right: '70px', top: '490px', width: '80px' })}
        />

        ${width > 1560
          ? html`
              <img
                src=${require('client/assets/background_images/dots.svg')}
                ${css({ position: 'absolute', right: '270px', top: '200px', width: '200px' })}
              />
            `
          : nothing}
        <img
          src=${require('client/assets/background_images/half_circle_green.svg')}
          ${css({ position: 'absolute', right: '0', top: '177px', width: '150px' })}
        />
      `
    : nothing;
};
